/* Site-Specific JavaScript */
jq(window).ready(function() {
    //video tracking analytics
    // video tags
    document.querySelectorAll("video").forEach(function (video) {
        // Skip if video has data-exclude-from-analytics attribute
        if (video.hasAttribute('data-exclude-from-analytics')) {
            return;
        }

        video.addEventListener("play", function () {
            var videoSrc = video.currentSrc || "unknown-video"; // Get video source URL
            var videoName = video.getAttribute("data-video-name") || videoSrc.split('/').pop() || "unknown-video"; // Extract filename
            
            // Remove the file extension (e.g., .mp4, .avi, etc.)
            var formattedVideoName = videoName.replace(/\.[^/.]+$/, '');
            // Replace white spaces with underscores
            formattedVideoName = formattedVideoName.replace(/\s+/g, '_');

            var trackingUrl = "/video/" + formattedVideoName;
            // Send request to tracking URL
            fetch(trackingUrl, { method: "GET", mode: "no-cors" });

        }, { once: true }); // Ensures tracking fires only once per video play
    });
    //links to videos on new tab for all links with the class "video-link"
    document.querySelectorAll(".video-link").forEach(function(link) {
        // Skip if link has data-exclude-from-analytics attribute
        if (link.hasAttribute('data-exclude-from-analytics')) {
            return;
        }

        link.addEventListener("click", function(e) {
            var linkHref = link.getAttribute("href");
            var videoName = linkHref.split('/').pop(); // Extract the file name from the URL (e.g., /path/video.mp4 -> video.mp4)

            // Remove the file extension (e.g., .mp4, .avi, etc.)
            var formattedVideoName = videoName.replace(/\.[^/.]+$/, '');
            // Replace white spaces with underscores
            formattedVideoName = formattedVideoName.replace(/\s+/g, '_');

            var trackingUrl = "/video/" + formattedVideoName;

            // Send request to tracking URL
            fetch(trackingUrl, { method: "GET", mode: "no-cors" });
        });
    });
    //Fancybox videos
    jq(document).on('afterShow.fb', function (e, instance, current) {
        // Skip if fancybox trigger has data-exclude-from-analytics attribute
        if (current.$trigger && current.$trigger[0] && current.$trigger[0].hasAttribute('data-exclude-from-analytics')) {
            return;
        }
        
        // Access the actual content container
        var content = current.$content[0];
        if (content) {
            var childNodes = content.childNodes;
            // Loop through child nodes to find an iframe and associated thumbnail
            for (var i = 0; i < childNodes.length; i++) {
                if (childNodes[i].nodeName === 'IFRAME') {
                    var iframe = childNodes[i];
                    // Check if iframe's outerHTML contains YouTube embed URL
                    var iframeSrc = iframe.getAttribute('src');
                    if (iframeSrc && iframeSrc.includes('www.youtube.com/embed/')) {
                        var videoId = iframeSrc.split('/').pop().split('?')[0]; // Extract the video ID

                        // Try to find the thumbnail image's alt attribute
                        var thumbnailAlt = '';
                        var thumbnailImage = current.$thumb.find('img'); // Look for images inside Fancybox content


                        thumbnailAlt = '';
                        if (thumbnailImage && thumbnailImage.prevObject && thumbnailImage.prevObject[0]) {
                          thumbnailAlt = thumbnailImage.prevObject[0].alt || '';
                        }
                        thumbnailAlt = thumbnailAlt.replace(/\bthumbnail\b/i, '').trim(); // Remove the word "thumbnail"
                        thumbnailAlt = thumbnailAlt.replace(/\s+/g, '_'); // Replace spaces with underscores
                        thumbnailAlt = thumbnailAlt.replace(/[^\w\s-_]/g, ''); // Remove special characters (e.g., ', ', ", &, etc.)
                        
                        // If both thumbnailAlt and videoId are empty, return without tracking
                        if (!thumbnailAlt && !videoId) {
                            return;
                        }
                        
                        // Use thumbnailAlt if available, otherwise use videoId
                        var video_name = thumbnailAlt || "youtube_id=" + videoId;

                        // Send the tracking request with the properly formatted URL
                        var trackingUrl = "/video/" + video_name;
                        fetch(trackingUrl, { method: "GET", mode: "no-cors" });
                    }
                }
            }
        }
    });
    //end of video analytics

    // Find any headings with {ani} and change to span
    let headingsResults = document.querySelectorAll('h1, h2');
    headingsResults.forEach((heading, index)=> {
            // Get the text content of the heading element
        const originalText = heading.innerHTML;
        // Perform the replace operation on the text content
        const transformedText = originalText.replace(/\{a\}(.*?)\{a\}/g, '<span class="animate-letters">$1</span>');
        // Update the inner HTML of the heading element with the transformed text
        heading.innerHTML = transformedText;
    });

    // This will execute whenever the window is resized
    var height = jq(window).height(); // New height
    var width = jq(window).width(); // New width

    function isScrolledIntoView(elem) {
      var docViewTop = jq(window).scrollTop();
      var docViewBottom = docViewTop + jq(window).height();

      var elemTop = jq(elem).offset().top;
      var elemBottom = elemTop + jq(elem).height();

      return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
    }

    jq("#history-filter select").on("change", function (e) {
        var year = jq('select#year').val();
        if (year) {
            jq('.year-wrapper.d-block').removeClass('d-block');
            jq('#year-' + year).addClass('d-block');
        }
    });

    var timelineFilter = jq(".module-timeline .year-filter");
    if(timelineFilter.length) {
        jq(timelineFilter).affix({
            offset: {
                top: jq(".module-timeline .year-filter").offset().top - jq("#header").outerHeight() - jq(".sub-navigation").outerHeight()
            }
        });
    }

    if (jq(".content-slider").length) {
        jq(".content-slider").slick(JSON.parse(document.getElementById("contentSlickOptions").innerText));
    }

    // Fixes the animate class not being added properly on screen resize or orientation change
    function reapplyAnimateClassOnResize(sliderClass) {
        jq(window).on('resize', function() {
            setTimeout(function() { // Ensure the slider adjusts to the new size
                var index = jq(sliderClass).slick('slickCurrentSlide');
                jq(sliderClass + ' .slick-slide').removeClass('animate');
                var currentSlide = jq(sliderClass + ' .slick-slide[data-slick-index="' + index + '"]');
                currentSlide.addClass('animate');
            }, 200); // Add slight delay to allow for the slider to adjust
        });
    }

    // home slider
    if (jq(".home-slider").length) {
        jq(".home-slider").on('init', function() {
            jq('.home-slider .slick-slide[data-slick-index="0"]').addClass('animate');
        });
        jq(".home-slider").slick(JSON.parse(document.getElementById("homeSlickOptions").innerText));
        jq(".home-slider").on('afterChange', function(event) {
            var index = jq(this).slick('slickCurrentSlide');
            jq('.home-slider .slick-slide').removeClass('animate');
            var currentSlide = jq('.home-slider .slick-slide[data-slick-index="' + index +'"]');
            currentSlide.addClass('animate');
        });

        reapplyAnimateClassOnResize('.home-slider');
    }
    // banner slider
    if (jq(".banner-slider").length) {
        jq(".banner-slider").on('init', function() {
            jq('.banner-slider .slick-slide[data-slick-index="0"]').addClass('animate');
        });
        jq(".banner-slider").slick({
            "infinite": false,
            "dots": true,
            "variableWidth": false,
            "variableHeight": true,
            "arrows": true,
            "fade": true,
            "autoplay": true,
            "autoplaySpeed": 8000,
            "prevArrow": "<div class='prev prev-arrow'></div>",
            "nextArrow": "<div class='next next-arrow'></div>",
            "appendArrows": ".slider-nav.banner",
            "appendDots": ".slider-nav.banner",
            "slidesToShow": 1,
            "slidesToScroll": 1,
            "responsive": [
                {
                  "breakpoint": 1199,
                  "settings": {
                    "slidesToShow": 1,
                    "variableWidth": false,
                    "slidesToScroll": 1
                  }
                },
                {
                  "breakpoint": 991,
                  "settings": {
                    "slidesToShow": 1,
                    "variableWidth": false,
                    "slidesToScroll": 1
                  }
                },
                {
                  "breakpoint": 767,
                  "settings": {
                    "slidesToShow": 1,
                    "variableWidth": false,
                    "slidesToScroll": 1
                  }
                }
              ]
            });
        jq(".banner-slider").on('afterChange', function(event) {
            var index = jq(this).slick('slickCurrentSlide');
            jq('.banner-slider .slick-slide').removeClass('animate');
            var currentSlide = jq('.banner-slider .slick-slide[data-slick-index="' + index +'"]');
            currentSlide.addClass('animate');
        });
        reapplyAnimateClassOnResize('.banner-slider');
    }

    // stats slider
    if (jq(".stats-slider").length) {
        jq(".stats-slider").slick(JSON.parse(document.getElementById("statsSlickOptions").innerText));
    }

    // teasers slider
    if (jq(".teasers-slider").length) {
        jq(".teasers-slider").slick(JSON.parse(document.getElementById("teasersSlickOptions").innerText));
    }

    // teasers slider panels
    if (jq(".teasers-slider-panels").length) {
        jq(".teasers-slider-panels").slick(JSON.parse(document.getElementById("teasersPanelsSlickOptions").innerText));
    }

    jq('.content-table .dropdown-btn').accessibleClick(function(e) {
        var target = '.' + jq(this).data('target');
        jq(this).toggleClass('close');
        jq(target).toggleClass('d-none');
    });
    jq('.back-to-top').affix({});

    function backToTop () {
        if (jq(document).scrollTop() > jq('body').outerHeight()- window.innerHeight - jq('footer').outerHeight()) {
            jq(".back-to-top").addClass("d-block");
        } else {
            jq(".back-to-top").removeClass("d-block");
        }
        // Push it out of footer once user reaches bottom
    //    if (jq(window).scrollTop() >= jq(document).height() - jq(window).height() - jq('footer').height()) {
    //       jq(".back-to-top").css('bottom', jq('footer').height() + "px");
    //    }
    }
    // Check if user is on bottom of screen and show back to top
    backToTop();
    jq(window).scroll(function() {
        backToTop();
    })

        //Wrap tables in div to prevent it from breaking on mobile
    jq('.module-outstanding-notes table, .responsive-table table, .xn-content table').each(function(){
        jq(this).wrap("<div class='table-wrapper'></div>");
    });
    check_tables();
    //check widths of table-wrapper and tables
    function check_tables() {
        jq('.table-wrapper').each(function() {
            if (jq(this).find('table').outerWidth() > jq(this).outerWidth()) {
                jq(this).addClass('scroll');
            } else {
                jq(this).removeClass('scroll');
            }
        });
    }
    jq(window).resize(function(e) {
        check_tables();
    });

    // Scroll back to top on year filter
    let yearFilterBtn = document.querySelector('.page-type-timeline .bootstrap-select button');
    if (yearFilterBtn) {
        let page = jq("html,body");
        yearFilterBtn.addEventListener("click", ()=> {
            let yearFilterLi = document.querySelectorAll('.page-type-timeline .bootstrap-select li');
            yearFilterLi.forEach(element => {
                element.addEventListener("click", ()=>{
                    page.animate({
                        scrollTop: jq('header').height()
                    }, "fast");
                });
            });
        });
        page.bind("scroll mousedown DOMMouseScroll mousewheel keyup", function(){
            page.stop();
        });
    }

    // Go back to top on search page when elastic pagination btns pressed
    waitForElm('.rc-pagination li').then((elm) => {
        let paginationLink = document.querySelectorAll('.rc-pagination li');
        paginationLink.forEach(element => {
            element.dataset.event = true;
            element.addEventListener("click", animateScroll);
        });
    });
    let count = 0;
    function animateScroll(e) {
        jq("html,body").animate({
            scrollTop: jq('header').height()
        }, "slow");
        // Stop the animation if user scrolls
        jq("html,body").bind("scroll mousedown DOMMouseScroll mousewheel keyup", function(){
            jq("html,body").stop();
        });
        // Check if new page numbers appeared and add event
        // Account for slight loading delay from elastic
        setTimeout(() => {
            let paginationLink = document.querySelectorAll('.rc-pagination li');
            paginationLink.forEach(element => {
                if (!element.hasAttribute("data-event")) {
                    element.dataset.event = true;
                    element.addEventListener("click", animateScroll);
                }
            });
        }, 300);
    }
    function waitForElm(selector) {
        return new Promise(resolve => {
            if (document.querySelector(selector)) {
                return resolve(document.querySelector(selector));
            }

            const observer = new MutationObserver(mutations => {
                if (document.querySelector(selector)) {
                    resolve(document.querySelector(selector));
                    observer.disconnect();
                }
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        });
    }
    jq('body:not(.page-type-search---elastic-search) li[data-submenu-id="submenu-search"] a').click(function(e) {
        e.preventDefault();
        document.querySelector('.search-bar').classList.toggle('d-none');
    });

    // Add active states to nav if gotten there by link
    // Get all the navigation links
    const navLinks = document.querySelectorAll('#sub-navigation > ul > li a');

    // Function to check if the URL contains an anchor link
    function hasAnchorLink() {
      return window.location.href.indexOf('#') > -1;
    }

    // Function to add the active class to the appropriate link
    function setActiveLink() {
      // Get the anchor link from the URL
      const anchorLink = window.location.hash;

      // Loop through the navigation links
      navLinks.forEach(link => {
          let linkLi = link.parentElement;
        // Check if the link's href matches the anchor link
        if (getAnchorTag(link) === anchorLink) {
          // Add the active class to the link
          linkLi.classList.add('active');
        } else {
          // Remove the active class from the link
          linkLi.classList.remove('active');
        }
      });
    }
    function getAnchorTag(link) {
        // Get the href attribute of the link element
        const href = link.getAttribute('href');

        // Get the index of the anchor tag in the href
        const index = href.indexOf('#');

        // Get the anchor tag from the href
        const anchorTag = index > -1 ? href.substring(index) : '';

        return anchorTag;
    }

    // Check if the URL contains an anchor link
    if (hasAnchorLink()) {
      // Add the active class to the appropriate link
      setActiveLink();
    }

    // Add a click event listener to each navigation link
    let mainLinks = document.querySelectorAll(".main-menu a")
    mainLinks.forEach(link => {
        link.addEventListener('click', () => {
        // Wait for a short time to let the URL change
        setTimeout(() => {
            // Check if the URL contains an anchor link
            if (hasAnchorLink()) {
                // Add the active class to the appropriate link
                setActiveLink();
            }
        }, 100);
        });
    });

});
/* Site-Specific JavaScript */
// Move 'page--animate-scroll' class from body to html element so css smooth scrolling can function

jq(document).ready(function () {

    if ( jq('body').hasClass('page--animate-scroll') ) {
        jq('html').addClass('page--animate-scroll');
    }
    // On click add active class to sub navigation links
    jq('.sub-navigation a[target="_self"]').click(function(){
        jq('.sub-navigation a[target="_self"]').parent().removeClass('active');
        jq(this).parent().addClass('active');
    });

    // Text Annimation (Life at AerCap page)
    let banner = document.querySelector('.page-banner-tall');
    if (banner) {
        banner.dataset.aos = '';
    }



    const slot = document.querySelectorAll('.page-banner-tall h1, .animate-letters, .animated-letters');

    // Loop through each target element
    slot.forEach((item, index) => {
        // Create a new div element with the class name 'slot'
        let slot_element = document.createElement('div');
        slot_element.className = 'slot';

        // Split the inner text of each target element into words
        let words = item.innerText.split(' ');

        // Loop through each word
        words.forEach((word, index) => {
            // Create a new div element for each word with the class name 'word'
            let word_element = document.createElement('div');
            word_element.className = 'word';

            // Split each word into letters
            let letters = word.split('');

            // Loop through each letter
            letters.forEach((letter, index) => {
                // Create a new div for each letter with class name 'letter-container' and a custom attribute
                const letterContainer = document.createElement('div');
                letterContainer.className = 'letter-container';
                letterContainer.setAttribute('data-text', letter + '\n' + letter);

                // Initialize letterCount and set min and max for random letter generation
                let letterCount = 0;
                const maxLetters = 10;
                const minLetters = 2;

                // Create random number of letter spans based on the current letter
                for (letterCount; letterCount < Math.floor(Math.random() * (maxLetters - minLetters + 1) + minLetters); letterCount++) {
                    let letter_span = document.createElement('span');
                    letter_span.classList.add('letter');
                    letter_span.innerText = letter;
                    letterContainer.appendChild(letter_span);
                }

                // Set translateY property based on the number of generated letters
                letterContainer.style.setProperty('--translate', -((letterCount - 1) * 100) + '%');

                // Append the letter container to the word element
                word_element.append(letterContainer);
            });

            // Append each word element to the slot element
            slot_element.append(word_element);
        });

        // Insert the slot element after the current target element
        item.parentNode.insertBefore(slot_element, item.nextSibling);

        // Hide the original text
        item.className = 'sr-only';

        // Generate an array of unique random indexes for animation
        let animatedIndexes = [];
        while (animatedIndexes.length < slot_element.querySelectorAll('.letter-container').length) {
            let randIndex = Math.floor(Math.random() * slot_element.querySelectorAll('.letter-container').length);
            if (!animatedIndexes.includes(randIndex)) {
                animatedIndexes.push(randIndex);
            }
        }

        // Animate the letters at the randomly generated indexes with a staggered delay
        let lastRandDelay = 0
        animatedIndexes.forEach((index, i) => {
            setTimeout(() => {
                const delayMax = 5;
                let randDelay;
                // Create random number and make sure it does not equalt last.
                do {
                    randDelay = Math.floor(Math.random() * (delayMax + 1));
                } while (randDelay == lastRandDelay);
                lastRandDelay = randDelay;

                slot_element.querySelectorAll('.letter-container')[index].style.setProperty('--delay', (randDelay * 100) + 'ms');
                slot_element.querySelectorAll('.letter-container')[index].classList.add('animate');
            }, i * 100); // 100 milliseconds delay for each
        });
    });

/*    // Get the element by its ID or any other query method
    const aosElements = document.querySelectorAll('.aos-init');

    // Get initial top offset of the element
    let elementTopOffset = myElement.getBoundingClientRect().top;

    // Add scroll event listener
    window.addEventListener('scroll', function() {
        const currentTopOffset = myElement.getBoundingClientRect().top;

        // Check if we're scrolling down and the element has moved out of the viewport
        if (currentTopOffset < 0 && currentTopOffset < elementTopOffset) {
            myElement.classList.remove('myClass');
        }

        // Update the last known top offset for the next scroll event
        elementTopOffset = currentTopOffset;
    });*/



    AOS.init();

    jq(".block-link.more-videos").on("click", function(e){
        e.preventDefault();
        if (jq(this).hasClass('active')) {
            jq(this).removeClass('active').text('More Videos');
        } else {
            jq(this).addClass('active').text('Fewer Videos');
        }

    });

    // Slick slider Play/Pause Buttons
    document.querySelectorAll('.slider-pause-btn').forEach(function(el) {
        let targetSlider = document.getElementById(el.dataset.target);

        if (targetSlider) {
            let $slider = jq(targetSlider); // jQuery reference
            let isPaused = false; // Track pause state manually

            el.addEventListener('click', function() {
                if (isPaused) {
                    $slider.slick('slickSetOption', 'autoplay', true).slick('slickPlay');
                    el.setAttribute('aria-label', 'Pause Slider');
                } else {
                    $slider.slick('slickSetOption', 'autoplay', false).slick('slickPause');
                    el.setAttribute('aria-label', 'Play Slider');
                }
                isPaused = !isPaused; // Toggle pause state
                el.classList.toggle('paused');
            });
        }
    });

    let tableContainer = jq('.table-wrapper');
    jq('.table-wrapper').on('keydown', function (event) {
        if (event.key === 'ArrowRight') {
            tableContainer.scrollLeft(tableContainer.scrollLeft() + 50); // Scrolls right
            event.preventDefault(); // Prevents cursor movement
        } else if (event.key === 'ArrowLeft') {
            tableContainer.scrollLeft(tableContainer.scrollLeft() - 50); // Scrolls left
            event.preventDefault();
        }
    });

}); // end document.ready
